<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-toolbar color="white" dark flat dense cad>
          <v-toolbar-title class="indigo--text"
            >Recepción de Materiales</v-toolbar-title
          >
        </v-toolbar>
      </v-flex>
    </v-layout>
    <grid-recepcion
      :key="recepcionGrid"
      :contratoId="contratoId"
    ></grid-recepcion>
  </v-container>
</template>

<script>
import GridRecepcion from "@/modules/captura/views/recepcion/GridRecepcion.vue";

export default {
  name: "recepcionCap-sub-tab",

  components: {
    GridRecepcion,
  },
  props: {
    proveedor: {},
    show: Boolean,
    tipeView: "",
  },
  data() {
    return {
      contratoId: "",
      recepcionGrid: 0,
    };
  },

  computed: {},

  created() {
    this.contratoId = this.$store.getters.contratoStored;
  },
  methods: {},
};
</script>
